import React from 'react';

/**
 * Checkbox container
 * @param data the data that will be displayed
 * @param handleCheckboxes what happens when a checkbox is clicked? Should be a function
 * @param orgID the orgID
 * @param isCheckboxDefaultChecked is the checkbox default checked? Should be a function
 * @param tagPrefix the tag prefix assigned to the checkboxes
 */
export const CheckboxContainer = ({
	data,
	handleCheckboxes,
	orgID,
	isCheckboxDefaultChecked,
	tagPrefix,
}) => {
	if (!data) {
		return null;
	}

	return (
		<ul className="tag-container">
			{data.map((tagObject) => {
				return (
					<div
						className="outer-container"
						id={tagObject.id}
						key={tagObject.name}
					>
						<label>
							<input
								type="checkbox"
								value={tagObject.name}
								className="checkbox"
								name={tagObject.id}
								id={tagPrefix + tagObject.id}
								onClick={(e) =>
									handleCheckboxes(e, tagPrefix, tagObject.id)
								}
								defaultChecked={
									orgID && isCheckboxDefaultChecked
										? () =>
												isCheckboxDefaultChecked(
													tagPrefix + tagObject.id
												)
										: false
								}
							/>
							<div className="checkbox-name body-font">
								{tagObject.name}
							</div>
						</label>
					</div>
				);
			})}
		</ul>
	);
};
